import primary from "./primaryTheme/primaryTheme";
import secondary from "./secondaryTheme/secondaryTheme";
import { LIGHT_THEME } from "../constants/themeConstants";

export const getTheme = () => {
  const selectedThemeStorage = undefined;
  // authScopeStringGetHelper("colorMode");

  if (
    selectedThemeStorage == undefined ||
    selectedThemeStorage === LIGHT_THEME
  ) {
    return { ...primary };
  }
  return { ...secondary };
};

const selectedTheme = getTheme();

export default selectedTheme;
